export const RESOURCE_ENDPOINT = '/ai-search/conversation/id'
